import { render, staticRenderFns } from "./StateFeeOfficial.vue?vue&type=template&id=19e0b18a"
import script from "./StateFeeOfficial.vue?vue&type=script&lang=ts"
export * from "./StateFeeOfficial.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports